import React from 'react';
import {Icons} from '../../../assets';
import {JobApplicationStatus} from '../../../models/job-application';

interface ApplicantStatusControlsProps {
  status: JobApplicationStatus;
  loadingStatus: JobApplicationStatus | null;
  onChange: (newStatus: JobApplicationStatus) => void;
}

export const ApplicantStatusControls: React.FC<ApplicantStatusControlsProps> = ({status, loadingStatus, onChange}) => {
  const isAccepting = loadingStatus === JobApplicationStatus.ACCEPTED;
  const isRejecting = loadingStatus === JobApplicationStatus.REJECTED;

  let content: React.ReactNode = null;

  if (status === JobApplicationStatus.ACCEPTED) {
    content = <span className="px-4 py-2 text-sm font-medium bg-lime-100 text-lime-700 rounded-full">Shortlisted</span>;
  } else if (status === JobApplicationStatus.REJECTED) {
    content = <span className="px-4 py-2 text-sm font-medium bg-red-100 text-red-600 rounded-full">Rejected</span>;
  } else {
    content = (
      <div className="flex flex-col sm:flex-row gap-2 w-full md:w-auto">
        <button
          onClick={() => onChange(JobApplicationStatus.REJECTED)}
          disabled={isRejecting}
          className={`flex items-center justify-center gap-2 px-4 py-2 text-sm text-white rounded-full transition 
            ${isRejecting ? 'bg-red-400 cursor-not-allowed' : 'bg-red-500 hover:bg-red-600'}`}>
          {isRejecting ? (
            <span className="animate-pulse">Rejecting...</span>
          ) : (
            <>
              <img src={Icons.XCIRCLE_WHITE} className="w-4 h-4" />
              <span>Reject</span>
            </>
          )}
        </button>

        <button
          onClick={() => onChange(JobApplicationStatus.ACCEPTED)}
          disabled={isAccepting}
          className={`flex items-center justify-center gap-2 px-4 py-2 text-sm text-white rounded-full transition 
            ${isAccepting ? 'bg-lime-500 cursor-not-allowed' : 'bg-lime-700 hover:bg-lime-800'}`}>
          {isAccepting ? (
            <span className="animate-pulse">Shortlisting...</span>
          ) : (
            <>
              <img src={Icons.CHECK_CIRCLE} className="w-4 h-4" />
              <span>Shortlist</span>
            </>
          )}
        </button>
      </div>
    );
  }

  return <>{content}</>;
};
